import { render, staticRenderFns } from "./systemKPI.vue?vue&type=template&id=f2d8b70c&scoped=true&"
import script from "./systemKPI.vue?vue&type=script&lang=js&"
export * from "./systemKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8b70c",
  null
  
)

export default component.exports